import { Modal } from 'antd';
import React from 'react';

const InvoiceModal = ({ isOpen, onClose }) => {
  return (
    <Modal width={600} footer={false} open={isOpen} onCancel={onClose}>
      <h1>Invoice</h1>
    </Modal>
  );
};

export default InvoiceModal;
